export default "__VITE_ASSET__DwyUrVNv__"